import { useContext, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Circle } from "@react-google-maps/api";
import { MapLoading } from "../App.styles";
import CustomMarkerOverlay from "../common/CustomMarkerOverlay";
import { OrganizeContext } from "../organize/Organize.context";
import theme from "../themes";

const ChallengeMarkers = ({ onMarkersLoaded }) => {
    const { t } = useTranslation();
    const { challenges } = useContext(OrganizeContext)
    const { isLoading: isLoadingChallenges, tasks = [] } = challenges || {}

    // Get markers from tasks/challenges
    const markers = useMemo(() => {
        return tasks.filter(t => t.latitude && t.longitude).map(({ id, latitude, longitude, unlock_by_location_radius }) => ({
        id,
        lat: latitude,
        lng: longitude,
        locked: unlock_by_location_radius > 0,
        radius: unlock_by_location_radius,
        }))
    }, [tasks])

    useEffect(() => {
        if (onMarkersLoaded && markers) {
            onMarkersLoaded(markers);
        }
    }, [markers, onMarkersLoaded]);

    return (
        <>
            {(isLoadingChallenges) && (
                <MapLoading>
                    {t(`Loading tasks...`)}
                </MapLoading>
            )}
            {markers.map((location) => {
                const { id, lat, lng, locked, radius } = location;
                return (
                    <>
                        <CustomMarkerOverlay
                            key={`${id}`} 
                            position={{ lat, lng }}
                            id={id}
                            locked={locked}
                            isDynamicIcon={true}
                        />
                        {lat && lng && locked && (
                            <Circle
                                center={{ lat, lng }}
                                radius={radius} // Google Maps uses meters for radius
                                options={{
                                    strokeColor: theme.primaryColor,
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: theme.primaryColor,
                                    fillOpacity: 0.35,
                                }}
                            />
                        )}
                    </>
                )
            })}
        </>
    )
}

export default ChallengeMarkers;